module.exports = __webpack_public_path__ + "img/水杯0.c4ca131f.png";